<template>
	<div class="phdetails">
		<el-backtop ></el-backtop>
		<div style="height: 0.88rem;">
		</div>
		<hpheader ref="hpheader"></hpheader>
		<div class="phdeta-head">
			<div class="phdetahea-left">
				{{detailnames}}
			</div>
			<div class="phdetahea-right" v-if="detail.template_id != 2">
				<el-select v-model="value" @change='selesac' placeholder="请选择" >
					<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>

    <div v-if="detail.template_id != 2">
      <div class="phdeta-img" v-if="valuid==1 && detail.template_id == 1">
        <!-- 旧版 上线删除 -->
        <!--        <div class="detailvideo" v-if="detavideosea">-->
        <!--          <video :src="detavideo" :poster="poster" controls></video>-->
        <!--        </div>-->
        <!--        <div class="content" v-html="htmlcontent"></div>-->
        <!--      最新修改暂时注释-->
        <detailContent ref="detailContent" :detail="detail"></detailContent>
      </div>
      <div v-if="valuid==1 && detail.template_id == 3">
        <specialEndo v-if="detail.template_name == 'endo'"></specialEndo>
      </div>
      <div class="phparamaete" v-if="valuid==2">
        <div class="phpaaemate-hea">
          <img :src="parameter" />
        </div>
        <div class="phpaameta-cont">
          <div class="phpaameta-item" v-for="(item,index) in productargcont" :key="index">
            <div class="parmetitem-name">
              {{item.title}}
            </div>
            <div v-html="item.content" class="parmetaiem-title">

            </div>
          </div>
        </div>
      </div>
      <div class="phparamfile" v-if="valuid==3">
        <detailDownload ref="detailDownload" :detail="detail"></detailDownload>

        <!--			<div class="phparfilecont">-->
        <!--				<div class="pharfile-hea">-->
        <!--					{{vidcenter}}-->
        <!--				</div>-->
        <!--				<div class="pharfile-filebut" v-for="(item,index) in filenavto" @click="navtoshiyan(item)" >-->
        <!--					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcdetailsimg/pdf.png" />-->
        <!--					<span>{{item.file_title}}. PDF</span>-->
        <!--				</div>-->
        <!--				<div class="pharfile-title">-->
        <!--					{{casesha}}: {{filetitle}} {{videonavall}}-->
        <!--				</div>-->
        <!--			</div>-->
      </div>
    </div>
    <detailTips ref="detailTipsRef" :detail="detail" v-else></detailTips>

		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage"
  import detailDownload from './components/detail-download.vue'
  import detailTips from './components/detail-tips.vue'
  import detailContent from "./components/detail-content.vue";
  import specialEndo from '@/components/special/mobile/endo/index.vue'
	export default{
		data(){
			return{
				videonavall:'',
				casesha:'',
				vidcenter:'',
				options:
						[{
							value: '1',
							label: '产品详情'
						}, {
							value: '2',
							label: '产品参数'
						}, {
							value: '3',
							label: '产品说明'
						}],
				value: '产品详情',
				valuid:1,
				detailnames:'',
				htmlcontent:'',
				parameter:'',
				contenttitle:'',
				productargcont:'',
				fiilecontent:'',
				filetitle:'',
				detavideo:'',
				detavideosea:true,
				poster:'',
				channel_id:session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				pageType:'',
        detail: {
          template_id: 1,
        },
        download: 0
			}
		},
		created() {
			this.getParams ()
			this.pcgetproductdetail()
			window.scrollTo(0,0);
			this.pageParam()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				this.$router.push({path:'./pcdetails',query:this.$route.query})
				return
			}
			this.ress()

		},
		watch:{

		},
		mounted() {

		},
		components:{
      detailDownload,
			hpfooter,
			hpheader,
      detailTips,
      detailContent,
      specialEndo
		},
		methods:{
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.vidcenter = "产品使用说明书预览"
					this.videonavall="产品使用说明书"
					this.casesha="备注"
					this.networkco="显示更多"
					this.value='产品详情'
					this.options=
							[{
								'value': '1',
								'label': '产品详情'
							}, {
								'value': '2',
								'label': '产品参数'
							}, {
								'value': '3',
								'label': '下载'
							}]
          if(this.download && this.download != 0){
            this.valuid = 3
            this.value = '下载'
          }
				}else{
					this.vidcenter = "Product manual Preview"
					this.videonavall="Product instructions"
					this.casesha="remarks"
					this.networkco="Show more"
					this.options=
							[{
								'value': '1',
								'label': 'Details'
							}, {
								'value': '2',
								'label': 'Specifications'
							}, {
								'value': '3',
								'label': 'Manual'
							}]
					this.value=this.options[0].label
				}
			},

			navtoshiyan(item){

				// let e=this.filenavto
				window.open(item.file)
				/* this.$router.push({path: '/pcshiyan',query:{e}}) */
			},
			pcgetproductdetail(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					id: this.detailid,
					mold:"h5",
				}
				this.$api.get_product_detail(data).then((res) => {

					// if(this.pageType == 'scan' && res.data.channel_ids){
					// 	let channel_ids = res.data.channel_ids.split(',')
					// 	if(channel_ids.indexOf(this.channel_id) == -1){
					// 		this.channel_id = channel_ids.length > 1 ? channel_ids.sort((a,b) => a - b)[0] : channel_ids[0]
					// 		session.set('channel_id',this.channel_id)
					// 		this.$refs.hpheader.setHeaderStyle()
					// 	}
					// }
          let channel_ids = res.data.channel_ids.split(',')
          if(channel_ids.indexOf(this.channel_id) == -1){
            this.channel_id = channel_ids.length > 1 ? channel_ids.sort((a,b) => a - b)[0] : channel_ids[0]
            session.set('channel_id',this.channel_id)
            this.$refs.hpheader.setHeaderStyle()
          }

          this.detail = res.data
					this.detailnames=res.data.name
					this.parameter=res.data.top_image
					this.htmlcontent=res.data.content

					this.contenttitle=res.data.title_content
					this.productargcont=res.data.productarg
					this.fiilecontent=res.data.file_content
					this.filetitle=res.data.file_title
					this.filenavto=res.data.producfile
					this.detavideo=res.data.video
					this.poster=res.data.image

          this.detail.cn_video_data = res.data.cn_video_data ? JSON.parse(res.data.cn_video_data) : []

          let parsedResourceData = res.data.cn_resource_data ? JSON.parse(res.data.cn_resource_data) : []
          parsedResourceData.sort((a, b) => (b.sort || 0) - (a.sort || 0))
          this.detail.cn_resource_data = parsedResourceData
          // this.detail.cn_resource_data = res.data.cn_resource_data ? JSON.parse(res.data.cn_resource_data) : []
          this.detail.cn_images_data = res.data.cn_images_data ? JSON.parse(res.data.cn_images_data) : []
					if(this.detavideo==''){
						this.detavideosea=false
					}
					/* this.productdetailiscion=res.data */
				});
			},
			selesac(){
				this.valuid=this.value
        let currentRoute = this.$route;
        let query = {...currentRoute.query}
        if(this.valuid == 3){
          query.download = 1
        }else {
          delete query.download
        }
        this.$router.push({
          path: currentRoute.path,
          query: query
        }).then(() => {
          console.log('Query parameter added or updated.');
        });
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			getParams () {
				this.detailid = this.$route.query.e
				this.pageType = this.$route.query.type
        this.download = this.$route.query.download

			}
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phdetails{
		background: #FFF;
	}
	.phdeta-head{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phdetahea-left{
		font-size: 0.32rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-left: 0.3rem;
	}
	.phdetahea-right{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
	}
	.phdetahea-right img{
		width: 0.28rem;
		height: 0.28rem;
		margin-right: 0.3rem;
		margin-left: 0.12rem;
	}
	.phdeta-img{
		width: 7.5rem;
		background: #FFFFFF;
	}
  .phdeta-img .content p {
    margin: 0!important;
    padding: 0!important;
  }
	.phdeta-img img{
		width: 100%;
		height: 100%;
    display: block;
	}

	.el-input{
		width: 2.3rem;
		max-width: 3rem;
	}
	.el-select .el-input.is-focus .el-input__inner{
		border-color: transparent;
	}
	.el-select .el-input__inner:focus{
		border-color: transparent;
	}
	.el-input__inner{
		border: none;
		border-color: transparent;
	}
	.phparamaete{

	}
	.phpaaemate-hea{
		width: 7.5rem;
		height: 4.08rem;
		margin-bottom: 0.32rem;
	}
	.phpaaemate-hea img{
		width: 100%;
		height: 100%;
	}
	.phpaameta-cont{
		display: flex;
		justify-content: center;
		flex-direction: column;
		padding: 0 0.3rem;
	}
	.phpaameta-item{

		width: 6.9rem;
		border-bottom: 0.01rem solid #ccc;
		margin-bottom: 0.32rem;
	}
	.parmetitem-name{
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.12rem;
		margin-bottom: 0.2rem;
	}
	.parmetaiem-title{
		margin-bottom: 0.32rem;
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
	}
	.phparamfile{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.phparfilecont{
		margin: 0.4rem 0;
		width: 6.8rem;
		background: #FAFAFA;
		border-radius: 0.1rem;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.pharfile-hea{
		font-size: 0.28rem;
		font-weight: 500;
		color: #5d5f5f;
		margin-top: 0.68rem;
	}
	.pharfile-filebut{
		padding: 0 0.27rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.24rem;
		font-weight: 500;
		height: 0.6rem;
		color: #FFFFFF;
		background: #D03E3D;
		border-radius: 0.05rem;
		margin-top: 0.3rem;
	}
	.pharfile-filebut span {
		padding-left: .15rem;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
		max-width: 5rem;
	}
	.pharfile-filebut img{
		width: 0.25rem;
		height: 0.33rem;
	}
	.pharfile-title{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.27rem;
		margin-bottom: 0.67rem;
	}
	.detailvideo video{
		display:block;
		width:100%;
	}
</style>
